function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.805 12.075H14.999V9.542H2.805V6.822H15.237V4.306H0V16.427H2.805V12.075Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.0918 13.792L27.3838 16.427H30.4268L24.1878 4.306H21.1788L15.0418 16.427H18.1188L19.3768 13.792H26.0918ZM22.6748 6.873L24.9358 11.48H20.4818L22.6748 6.873Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M33.529 16.427H36.436L42.369 4.306H39.292L35.093 13.299L31.251 4.306H28.14L33.529 16.427Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M43.7275 16.427H50.5615C53.2475 16.427 55.0665 16.019 56.0185 14.999C56.4945 14.506 56.7325 13.792 56.7325 12.908V12.84C56.7325 11.123 55.8825 10.443 53.9275 10.171C55.6615 9.848 56.4265 9.151 56.4265 7.587V7.485C56.4265 5.054 54.4715 4.306 50.4425 4.306H43.7275V16.427ZM46.4985 6.55H50.6125C52.0745 6.55 52.9075 6.618 53.3155 6.958C53.5195 7.145 53.6215 7.417 53.6215 7.808V7.876C53.6215 8.607 53.1115 8.913 52.2445 9.032C51.7855 9.083 51.3095 9.1 50.7145 9.1H46.4985V6.55ZM46.4985 11.31H50.4085C52.1935 11.31 53.1285 11.395 53.5195 11.786C53.7235 11.973 53.8255 12.262 53.8255 12.653V12.721C53.8255 13.435 53.5195 13.792 52.4655 13.928C51.9385 14.013 51.2075 14.047 50.2045 14.047H46.4985V11.31Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M65.4654 16.767C68.3214 16.767 70.5654 15.866 71.7894 14.013C72.4354 13.078 72.7244 11.922 72.7244 10.511V10.392C72.7244 7.638 71.3984 5.734 69.1884 4.748C68.0664 4.255 66.8594 4 65.4484 4C62.6434 4 60.4164 5.02 59.1584 6.941C58.5464 7.893 58.2234 9.049 58.2234 10.409V10.494C58.2234 13.418 59.4644 15.22 61.6574 16.104C62.7454 16.563 64.0034 16.767 65.4654 16.767ZM65.4484 14.183C62.7624 14.183 61.1644 13.027 61.1644 10.477V10.46C61.1644 7.689 62.7624 6.567 65.4654 6.567C67.2674 6.567 68.5424 7.043 69.2564 8.182C69.6134 8.777 69.7834 9.525 69.7834 10.477V10.494C69.7834 12.313 69.0524 13.367 67.7604 13.826C67.1144 14.081 66.3664 14.183 65.4484 14.183Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M80.079 11.82L83.955 16.427H87.508L81.898 9.967L87.1 4.306H83.513L80.113 8.318L76.696 4.306H73.143L78.243 9.984L72.429 16.427H76.084L80.079 11.82Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 89.64,
  width: 20,
  height: 9,
  fill: "#2E5AF6"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M91.64 7.00007H92.4696V6.32109H92.5406C92.694 6.5995 93.0065 7.08529 93.8019 7.08529C94.8588 7.08529 95.6258 6.2387 95.6258 4.82677C95.6258 3.412 94.8474 2.57961 93.7934 2.57961C92.9838 2.57961 92.6912 3.07393 92.5406 3.34382H92.4894V1.18188H91.64V7.00007ZM92.4724 4.81825C92.4724 3.90632 92.8701 3.3012 93.6116 3.3012C94.3815 3.3012 94.7679 3.95177 94.7679 4.81825C94.7679 5.69325 94.3701 6.36086 93.6116 6.36086C92.8815 6.36086 92.4724 5.73586 92.4724 4.81825Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M98.5403 7.08813C99.492 7.08813 100.165 6.61939 100.359 5.90916L99.5545 5.76427C99.4011 6.1762 99.0318 6.38643 98.5488 6.38643C97.8216 6.38643 97.3329 5.91484 97.3102 5.07393H100.412V4.77279C100.412 3.19609 99.4693 2.57961 98.4807 2.57961C97.2648 2.57961 96.4636 3.50575 96.4636 4.84666C96.4636 6.20177 97.2534 7.08813 98.5403 7.08813ZM97.3131 4.43757C97.3471 3.81825 97.796 3.28132 98.4863 3.28132C99.1454 3.28132 99.5773 3.76995 99.5801 4.43757H97.3131Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M103.472 2.63643H102.577V1.59098H101.728V2.63643H101.088V3.31825H101.728V5.89495C101.725 6.68757 102.33 7.07109 103 7.05688C103.27 7.05404 103.452 7.00291 103.551 6.96598L103.398 6.26427C103.341 6.27563 103.236 6.3012 103.1 6.3012C102.824 6.3012 102.577 6.21029 102.577 5.71882V3.31825H103.472V2.63643Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M105.761 7.09666C106.483 7.09666 106.889 6.73018 107.051 6.40348H107.085V7.00007H107.915V4.10234C107.915 2.83245 106.915 2.57961 106.222 2.57961C105.432 2.57961 104.705 2.89779 104.42 3.69325L105.219 3.87507C105.344 3.56541 105.662 3.26711 106.233 3.26711C106.781 3.26711 107.063 3.55404 107.063 4.04836V4.06825C107.063 4.37791 106.744 4.37223 105.96 4.46313C105.134 4.55973 104.287 4.77563 104.287 5.76711C104.287 6.62507 104.932 7.09666 105.761 7.09666ZM105.946 6.41484C105.466 6.41484 105.119 6.19893 105.119 5.77848C105.119 5.32393 105.523 5.162 106.014 5.09666C106.29 5.05973 106.943 4.98586 107.065 4.8637V5.4262C107.065 5.94325 106.653 6.41484 105.946 6.41484Z",
  fill: "white"
});

var SvgLogoInverted = function SvgLogoInverted(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 17,
    viewBox: "0 0 110 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoInverted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-inverted.63547240.svg";
export { ForwardRef as ReactComponent };